import { gql } from "@apollo/client";

const schema = {
  get: {
    name: "actionNew",
    serviceName: "graphql",
    query: gql`
      query actionNew($ids: [String]) {
        actionNew(ids: $ids) {
          data {
            type
            title
            alias
            color
            details
          }
        }
      }
    `,
  },
  update: {
    name: "updateActionNew",
    serviceName: "admin",
    query: gql`
      mutation updateActionNew(
        $ids: [String]!
        $type: String
        $title: String
        $alias: String
        $color: String
        $details: String
      ) {
        updateActionNew(
          ids: $ids
          type: $type
          title: $title
          alias: $alias
          color: $color
          details: $details
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
